const digest = 'cfdf018681ffed4345d86a0953ad2dcac637e3ac54bc10e85463ebd453f73a19';
const css = `aside._offlineWarning_1yc99_1{padding:0 10px;position:fixed;width:100%;z-index:1002}`;
(function() {
  if (global.BROWSER && !document.getElementById(digest)) {
    var el = document.createElement('style');
    el.id = digest;
    el.textContent = css;
    document.head.appendChild(el);
  }
})();
export default { 'offlineWarning': '_offlineWarning_1yc99_1' };
export const offlineWarning = '_offlineWarning_1yc99_1';
export { css, digest };